import { isEqual } from 'lodash';

import type { TView } from '@src/shared/types/view';
import type { ColumnOrderState } from '@tanstack/table-core';

export const getIsColumnOrderChanged = ({
  currentColumnOrder,
  initialColumnOrder,
  currentView,
}: {
  initialColumnOrder: string[];
  currentColumnOrder: ColumnOrderState;
  currentView?: TView;
}) => {
  if (!currentColumnOrder.length) return false;

  const currentViewOrdering = currentView?.visible_static_fields.ordering;

  return !isEqual(
    currentColumnOrder,
    currentViewOrdering?.length ? currentViewOrdering : initialColumnOrder
  );
};
